const UNSAVED_MESSAGE =
    'This clears the quote you are building and returns you to the first step. Everything entered so far will be lost.';

export function buildStartOverMessage(quoteRef?: string): string {
    if (!quoteRef) return UNSAVED_MESSAGE;
    return `This clears the quote from this screen and returns you to the first step. Quote ${quoteRef} has already been saved and stays available from Agreements.`;
}
